export {
    createSiteBuilderBlockUuid as createShopBlockUuid,
    regenerateSiteBuilderBlockUuids as regenerateShopBlockUuids,
    withSiteBuilderBlockUuids as withShopBlockUuids,
} from "./siteBlockIdentity";
